export const Channels = {
  WHOLESALER: 'PR',
  RETAIL: 'DT',
  EXPORT: 'EX',
  INDUSTRIAL: 'IN',
  MODERN: 'MD',
  PROJECT: 'PG',
  ECOMMERCE: 'GR',
};

export const ChannelNames = {
  [Channels.WHOLESALER]: 'DISTRIBUCIÓN',
  [Channels.RETAIL]: 'MOSTRADORES',
  [Channels.EXPORT]: 'EXPORTACIÓN',
  [Channels.INDUSTRIAL]: 'INDUSTRIA',
  [Channels.MODERN]: 'CANAL MODERNO',
  [Channels.PROJECT]: 'PROYECTOS',
  [Channels.ECOMMERCE]: 'ECOMERCE',
};
